import Quiz from "~/hec/assets/icons/quiz";
import Star from "~/hec/assets/icons/star";
import type { TransformedModule } from "~/hooks/learning-center/transformers";
import { cn } from "~/lib/utils";

/**
 * SFCC-11505 — port of composable `moduleProgress.jsx`. A purely-visual progress
 * strip: one star per lesson (dimmed until complete) joined by connector lines,
 * then a quiz icon (dimmed until the quiz is complete). No percentage computed.
 */
interface ModuleProgressProps {
  lessons: TransformedModule["lessons"];
  quiz: TransformedModule["quiz"];
}

const ModuleProgress = ({ lessons, quiz }: ModuleProgressProps) => (
  <div className="mb-[2.375rem] flex items-center" data-testid="moduleProgress">
    {lessons?.map((lesson, i) => (
      <div className="contents" key={lesson.id ?? `lesson-${i}`}>
        <div
          className={cn(
            "mr-1 flex items-center justify-center lg:mr-0 lg:h-[3.125rem] lg:w-[3.125rem] lg:rounded-full lg:bg-primary",
            !lesson.complete && "opacity-40",
          )}
        >
          <Star className="h-[1.3125rem] w-6 text-primary lg:text-primary-foreground" />
        </div>
        <div
          className={cn(
            "mx-3 hidden h-0.5 grow bg-primary lg:block",
            !lesson.complete && "opacity-40",
          )}
        />
      </div>
    ))}
    {quiz && (
      <div
        className={cn(
          "flex items-center justify-center lg:h-[3.125rem] lg:w-[3.125rem] lg:rounded-full lg:bg-primary",
          !quiz.complete && "opacity-40",
        )}
      >
        <Quiz className="h-[1.3125rem] w-6 text-primary lg:text-primary-foreground" />
      </div>
    )}
  </div>
);

export default ModuleProgress;
